import { useTheme } from 'styled-components';

import MissionProgressCard from 'components/dashboard/cardinal/progress/MissionProgressCard';
import { ReportSection, ReportSectionHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

import AverageCard from './average/AverageCard';
import DailyTrendGraph from './average/DailyTrendGraph';
import AudienceStats from './insight/AudienceStats';
import CommentsStats from './insight/CommentsStats';
import ContentsTypeStats from './insight/ContentsTypeStats';
import CreatorCategoryStats from './insight/CreatorCategoryStats';
import HighValueRanking from './insight/HighValueRanking';
import More1000FollowerRanking from './insight/More1000FollowerRanking';
import ProgressStatusCard from './progress/ProgressStatusCard';
import CreatorRanking from './rank/CreatorRanking';

const CardinalDashboard = () => {
	const theme = useTheme();

	return (
		<ReportSection>
			<Grid flex="start" direction="column" _gap="100px">
				<Grid>
					<ReportSectionHeader>진행 현황</ReportSectionHeader>

					<Grid _height="128px" flex="start" _gap="16px" _margin="0 0 32px 0">
						<ProgressStatusCard />
					</Grid>
					<Grid flex="start" direction="column" _gap="16px">
						<Grid _height="100%" flex="between" _gap="16px">
							<MissionProgressCard />
						</Grid>
					</Grid>
				</Grid>

				<Grid flex="start" align_items="start" direction="column">
					<ReportSectionHeader>콘텐츠 성과</ReportSectionHeader>
					<Text typo="p">
						현재 기수 크리에이터들이 현재까지 참여한 미션의 좋아요, 댓글, 조회 수와
						소셜비즈 발송 수, 클릭 수 데이터를 포함합니다.
					</Text>

					<Grid _height="336px" _margin="32px 0 16px 0">
						<DailyTrendGraph />
					</Grid>

					<Grid>
						<AverageCard />
					</Grid>
				</Grid>

				<Grid>
					{/* 크리에이터 랭킹 */}
					<ReportSectionHeader>크리에이터 랭킹</ReportSectionHeader>
					<Text typo="p" _margin="0 0 16px 0">
						현재 기수 크리에이터들이 현재까지 참여한 미션을 기반으로 한 순위입니다.
					</Text>
					<Grid>
						<CreatorRanking />
					</Grid>
				</Grid>
				<Grid>
					{/* 크리에이터 인사이트 분석 */}
					<ReportSectionHeader>크리에이터 인사이트 분석</ReportSectionHeader>
					<Text typo="p" _margin="0 0 16px 0">
						크리에이터 중 top5에 해당하는 고성과 크리에이터 특성을 분석합니다. 이 섹션은
						모든 미션 종료 후 노출됩니다.
					</Text>

					<Grid
						_height="390px"
						_margin="0 0 16px 0"
						flex="start"
						_gap="16px"
						align_items="start"
					>
						<HighValueRanking />
						<AudienceStats />
					</Grid>
					<Grid _height="340px" flex="start" direction="column" _gap="16px">
						<Grid _height="308px" flex="start" _gap="16px">
							<CreatorCategoryStats />
							<ContentsTypeStats />
							<CommentsStats />
						</Grid>
					</Grid>

					<Grid>
						<Text typo="h4" color={theme.colors.gray.gray80_text} _margin="0 0 24px 0">
							고성과 크리에이터에 댓글 남긴 계정 중 팔로워 1,000명 이상 보유 계정
						</Text>
						<More1000FollowerRanking />
					</Grid>
				</Grid>
			</Grid>
		</ReportSection>
	);
};

const { Grid, Text } = style;

export default CardinalDashboard;
